module.exports = __webpack_public_path__ + "img/Z60_06.1dc5f134.jpg";